import BreyniaB1 from '../Breynia B/Breynia B (1).webp'
import BreyniaB2 from '../Breynia B/Breynia B (2).webp'
import BreyniaB3 from '../Breynia B/Breynia B (3).webp'
import BreyniaB4 from '../Breynia B/Breynia B (4).webp'
import BreyniaB5 from '../Breynia B/Breynia B (5).webp'


const BreyniaBimages =[
BreyniaB1,BreyniaB2,BreyniaB3,BreyniaB4,BreyniaB4,BreyniaB5
]

export default BreyniaBimages;